<script>

import TheHero from '@/components/PromoSite/HomePage/TheHero'
import GamesSection from '@/components/PromoSite/HomePage/GamesSection'
import StrategicPartnerships from '@/components/PromoSite/HomePage/StrategicPartnerships'
import TestimonialsBlock from '@/components/PromoSite/HomePage/TestimonialsBlock'
import ComprehensiveApproach from '@/components/PromoSite/HomePage/ComprehensiveApproach/ComprehensiveApproach'
import TherapyManagementBlock from '@/components/PromoSite/HomePage/TherapyManagementBlock'
import BookPromo from '@/components/PromoSite/HomePage/BookPromo'
import CookieLaw from 'vue-cookie-law'
import { mapGetters } from 'vuex'
import { goToRef } from '@/mixins/global'

export default {
  name: 'HomeView',
  components: {
    TheHero,
    GamesSection,
    StrategicPartnerships,
    TestimonialsBlock,
    ComprehensiveApproach,
    BookPromo,
    CookieLaw,
    TherapyManagementBlock
  },
  mixins: [goToRef],
  data () {
    return {
      showTree: false
    }
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'brochure/libraryInfo',
      workingLibrary: 'ovb/workingLibrary'
    }),
    heroHeight () {
      return this.$mq === 'mobile' ? '100vh' : '100vh'
    },
    heroSlides () {
      return [
        {
          title: '<div class="hero-title mb-2 text-outline-light">Therapeutic Gaming</div>',
          content: '<div class="hero-content mb-5 text-outline-dark">Our Visual Brain is a perceptual and academic<br>skill building platform you and your patient<br>use together.</div>',
          buttonLabel: 'Learn More',
          duration: 5,
          event: 'GOTO_GAMING'
        },
        {
          title: '<div class="hero-title mb-2">Flexible. Adaptable.</div>',
          content: '<div class="hero-content mb-5">Use in-office, at home, or during telehealth.<br>Therapy on your terms.</div>',
          // buttonLabel: 'Learn More',
          duration: 5
          // event: 'GOTO_FEATURES'
        },
        {
          title: '<div class="hero-title mb-2">Accessible Anywhere</div>',
          content: '<div class="hero-content mb-5">The Our Visual Brain platform is Cloud-based<br> &amp; runs on any device with a modern web-browser<br>and internet connection.</div>',
          // buttonLabel: 'Learn More',
          duration: 5
          // event: 'GOTO_FEATURES'
        }
      ]
    },
    isLoading () {
      return this.loading > 0
    },
    currentRoute () {
      return this.$router.currentRoute
    },
    // userInfo () {
    //   return this.$store.state.user.userInfo
    // },
    isMobile () {
      return ((this.$mq === 'mobile') || (this.$mq === 'tablet'))
    },
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    }
  },
  mounted () {
    // Check for logout query parameter
    if (this.$route.query.logout) {
      const logoutType = this.$route.query.logout
      let message = 'You\'ve been logged out successfully'

      if (logoutType === 'expired') {
        message = 'Your session has expired. You\'ve been logged out successfully.'
      }

      // Show logout toast notification
      this.$buefy.toast.open({
        message: message,
        type: 'is-success',
        duration: 3000,
        position: 'is-top'
      })

      // Clear the query parameter from URL without reloading
      this.$router.replace({ name: 'HomeView' })
    }

    // If user is already logged in, redirect to their home page
    // This handles the case where authenticated users navigate to the home page
    if (this.$store.getters['user/isLoggedIn'] && this.$store.state.user.userInfo) {
      const homePath = this.$store.state.user.userInfo.homePath
      if (homePath) {
        this.$router.push({ name: homePath })
      }
    }
  },
  methods: {
    onGotoGaming () {
      this.$router.push({ name: 'FeaturesView' })
    }
  }
}
</script>

<template>
  <section
    class='home-view'
  >
    <div
      class="home-view-no-auth"
    >
      <the-hero
        :height="heroHeight"
        :auto-play="true"
        :slides="heroSlides"
        @GOTO_GAMING="onGotoGaming"
      />
      <div ref="betterFoundation">
        <games-section />
      </div>
      <strategic-partnerships />
      <testimonials-block />
      <comprehensive-approach />
      <therapy-management-block />
      <book-promo />
    </div>
    <!-- PRETTY SURE THIS GOES AWAY -->
<!--    <div-->
<!--      v-if="!userInfo.appUserId"-->
<!--      class="free-demo"-->
<!--    >-->
<!--      <button-->
<!--        @click="onFreeTrial"-->
<!--        class="is-hidden-mobile text-outline-light is-rounded is-watermelon button is-large is-family-semibold">-->
<!--        Start Your Free Trial!-->
<!--      </button>-->
<!--    </div>-->
  </section>
</template>

<style
  lang="scss"
  scoped
>
  .home-view {
    background-image: linear-gradient(to right, #faf3f0, #fdfaf9);
    .free-demo {
      position: fixed;
      top: 6rem;
      right: 2rem;
      z-index: 99;
    }
  }
</style>
